__webpack_require__.p = "https://www.ikea.com/ca/en/purchase-agent/cart-tmp/";